import { render } from "./VIPRegisterForm.vue?vue&type=template&id=e182701a"
import script from "./VIPRegisterForm.vue?vue&type=script&lang=js"
export * from "./VIPRegisterForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__